export default class PartialSearchOrganizationInLegalNameError extends Error {

}
